import { $, $$ } from "./util.js";

// Mobile-only floating CTA: appears after the hero, steps aside when the page
// already shows a conversion element (CTA band, form, footer) or the cookie banner.
export function initStickyCta() {
  const bar = $("#stickyCta");
  if (!bar) return;
  const link = $("a", bar);
  const mq = window.matchMedia("(max-width: 768px)");
  const blockers = $$(".cta-band, form, .ftr");
  const inView = new Set();
  let past = false;

  const update = () => {
    const cookieOpen = (() => { const c = $("#cookie"); return !!c && !c.hidden; })();
    const on = mq.matches && past && inView.size === 0 && !cookieOpen;
    bar.classList.toggle("is-on", on);
    bar.setAttribute("aria-hidden", String(!on));
    if (link) link.tabIndex = on ? 0 : -1;
  };

  window.addEventListener("scroll", () => { past = window.scrollY > 700; update(); }, { passive: true });
  mq.addEventListener("change", update);

  if ("IntersectionObserver" in window) {
    const io = new IntersectionObserver((es) => {
      es.forEach((e) => (e.isIntersecting ? inView.add(e.target) : inView.delete(e.target)));
      update();
    });
    blockers.forEach((el) => io.observe(el));
  }
  const ck = $("#cookie");
  if (ck) new MutationObserver(update).observe(ck, { attributes: true, attributeFilter: ["hidden"] });
  update();
}
